import React, { useEffect, useRef, useState } from "react";
import { Icon } from "../shared/components";

/* ── Ícones inline para os 4 tipos de resolução ── */
function IconResolved()   { return <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8" stroke="#25D366" strokeWidth="1.6"/><path d="M5.5 9l2.5 2.5 4.5-4.5" stroke="#25D366" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>; }
function IconNoReturn()   { return <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8" stroke="#F5A524" strokeWidth="1.6"/><path d="M9 5v4l2.5 2.5" stroke="#F5A524" strokeWidth="1.8" strokeLinecap="round"/></svg>; }
function IconForwarded()  { return <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8" stroke="#3B9DFF" strokeWidth="1.6"/><path d="M7 6l4 3-4 3" stroke="#3B9DFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>; }
function IconSpam()       { return <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8" stroke="#F75555" strokeWidth="1.6"/><path d="M6.5 6.5l5 5M11.5 6.5l-5 5" stroke="#F75555" strokeWidth="1.8" strokeLinecap="round"/></svg>; }

const RESOLUTION_OPTIONS = [
  { id: "resolved",  label: "Resolvido",     hint: "Cliente teve a demanda atendida",   Icon: IconResolved,  color: "var(--success)"  },
  { id: "no_return", label: "Sem retorno",   hint: "Cliente não respondeu",             Icon: IconNoReturn,  color: "var(--warning)"  },
  { id: "forwarded", label: "Encaminhado",   hint: "Caso transferido para outra área",  Icon: IconForwarded, color: "var(--info)"     },
  { id: "spam",      label: "Spam / Inválido", hint: "Mensagem indesejada ou erro",     Icon: IconSpam,      color: "var(--danger)"   },
];

const QUICK_TAGS = ["venda", "suporte", "duvida", "reclamacao", "orcamento", "urgente"];

export default function FinalizeModal({ conversation, api, onConfirm, onBack }) {
  const [resolution, setResolution]   = useState("resolved");
  const [tags, setTags]               = useState([]);
  const [tagInput, setTagInput]       = useState("");
  const [summary, setSummary]         = useState("");
  const [createOpp, setCreateOpp]     = useState(false);
  const [requestNps, setRequestNps]   = useState(true);
  const [saving, setSaving]           = useState(false);
  const [error, setError]             = useState("");
  const tagRef = useRef(null);

  // Close on Escape
  useEffect(() => {
    function onKey(e) { if (e.key === "Escape") onBack?.(); }
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onBack]);

  function addTag(value) {
    const t = value.trim().toLowerCase().replace(/[^a-z0-9áéíóúãõàèìòùâêîôûç\-_]/gi, "").slice(0, 32);
    if (!t || tags.includes(t)) { setTagInput(""); return; }
    setTags((prev) => [...prev, t]);
    setTagInput("");
  }
  function removeTag(t) { setTags((prev) => prev.filter((x) => x !== t)); }
  function toggleQuickTag(t) {
    if (tags.includes(t)) removeTag(t);
    else setTags((prev) => [...prev, t]);
  }

  async function handleFinalize() {
    if (!resolution) return setError("Selecione como foi resolvida a conversa.");
    setError("");
    setSaving(true);
    try {
      const res = await api.post(`/conversations/${conversation.id}/finalize`, {
        resolution_type:      resolution,
        finalization_summary: summary.trim() || null,
        finalization_tags:    tags.join(", ") || null,
        create_opportunity:   createOpp,
        request_nps:          requestNps,
      });
      // Surface non-blocking warnings (NPS failed, etc.)
      const { nps_error, lead_created } = res.data || {};
      if (nps_error) console.warn("[FinalizeModal] NPS warning:", nps_error);
      if (lead_created) console.info("[FinalizeModal] Lead criado:", lead_created);
      onConfirm?.({ lead_created, nps_sent: res.data?.nps_sent, nps_error });
    } catch (err) {
      setError(err?.response?.data?.error || "Erro ao finalizar conversa.");
    } finally {
      setSaving(false);
    }
  }

  const convLabel = `Conversa #conv${conversation?.id} · ${(conversation?.contact_name || "").toUpperCase()}`;

  return (
    <div className="finModal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onBack?.(); }}>
      <div className="finModal-box" role="dialog" aria-modal="true">

        {/* Header */}
        <div className="finModal-header">
          <div>
            <div className="finModal-title">Finalizar atendimento</div>
            <div className="finModal-subtitle">{convLabel}</div>
          </div>
          <button type="button" className="finModal-close" onClick={onBack} aria-label="Fechar">
            <Icon name="close" size={14} />
          </button>
        </div>

        {/* Body */}
        <div className="finModal-body">

          {/* Como foi resolvido */}
          <div className="finModal-section">
            <div className="finModal-fieldLabel">
              Como foi resolvido? <span className="finModal-req">*</span>
            </div>
            <div className="finModal-resolutionGrid">
              {RESOLUTION_OPTIONS.map((opt) => (
                <button
                  key={opt.id}
                  type="button"
                  className={`finModal-resCard${resolution === opt.id ? " is-selected" : ""}`}
                  data-color={opt.id}
                  onClick={() => setResolution(opt.id)}
                >
                  <div className="finModal-resCard-icon"><opt.Icon /></div>
                  <div className="finModal-resCard-text">
                    <strong>{opt.label}</strong>
                    <span>{opt.hint}</span>
                  </div>
                  {resolution === opt.id && (
                    <div className="finModal-resCard-check">
                      <Icon name="check" size={11} />
                    </div>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Tags */}
          <div className="finModal-section">
            <div className="finModal-fieldLabel">Tags</div>
            <div
              className="finModal-tagInput"
              onClick={() => tagRef.current?.focus()}
            >
              {tags.map((t) => (
                <span key={t} className="finModal-tagChip">
                  {t}
                  <button type="button" onClick={() => removeTag(t)} aria-label="Remover">×</button>
                </span>
              ))}
              <input
                ref={tagRef}
                value={tagInput}
                onChange={(e) => setTagInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === ",") { e.preventDefault(); addTag(tagInput); }
                  if (e.key === "Backspace" && !tagInput && tags.length) removeTag(tags[tags.length - 1]);
                }}
                placeholder={tags.length === 0 ? "Adicionar tag (Enter para confirmar)" : ""}
              />
            </div>
            <div className="finModal-quickTags">
              {QUICK_TAGS.map((t) => (
                <button
                  key={t}
                  type="button"
                  className={`finModal-quickTag${tags.includes(t) ? " is-active" : ""}`}
                  onClick={() => toggleQuickTag(t)}
                >
                  {tags.includes(t) ? "✓" : "+"} {t}
                </button>
              ))}
            </div>
            <div className="finModal-hint">Categorize esta conversa para relatórios</div>
          </div>

          {/* Resumo */}
          <div className="finModal-section">
            <div className="finModal-fieldLabel">Resumo do atendimento</div>
            <textarea
              className="finModal-textarea"
              rows={4}
              value={summary}
              onChange={(e) => setSummary(e.target.value)}
              placeholder="Ex: Cliente solicitou orçamento de plano Premium, ficou de retornar amanhã com decisão."
              disabled={saving}
            />
            <div className="finModal-hint">Visível no histórico do contato</div>
          </div>

          {/* Toggles */}
          <div className="finModal-section finModal-togglesSection">
            <label className="finModal-toggleRow">
              <span className={`finModal-toggleSwitch${createOpp ? " is-on" : ""}`} onClick={() => setCreateOpp((v) => !v)}>
                <span className="finModal-toggleThumb" />
              </span>
              <span className="finModal-toggleLabel">Criar oportunidade no funil de vendas</span>
            </label>
            <label className="finModal-toggleRow">
              <span className={`finModal-toggleSwitch${requestNps ? " is-on" : ""}`} onClick={() => setRequestNps((v) => !v)}>
                <span className="finModal-toggleThumb" />
              </span>
              <span className="finModal-toggleLabel">Solicitar avaliação automática (NPS) ao cliente</span>
            </label>
          </div>

          {error && <div className="finModal-error"><Icon name="warning" size={13} /> {error}</div>}
        </div>

        {/* Footer */}
        <div className="finModal-footer">
          <button type="button" className="btn btn-ghost" onClick={onBack} disabled={saving}>
            Voltar
          </button>
          <div style={{ flex: 1 }} />
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleFinalize}
            disabled={saving || !resolution}
          >
            <Icon name="checkCircle" size={14} />
            {saving ? "Finalizando…" : "Finalizar conversa"}
          </button>
        </div>
      </div>
    </div>
  );
}
